module.exports = __webpack_public_path__ + "assets/img/ph_project_list.3939144b.svg";